import { Link, Outlet } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { useAuth } from '../state/AuthContext';
import { roleHome } from '../lib/roleNavigation';

export function PublicLayout() {
  const { user } = useAuth();
  return (
    <div className="public-shell">
      <header className="public-header">
        <Logo />
        <nav>
          <Link to="/about">About</Link>
          <Link to="/classes">Classes</Link>
          <Link to="/sample-quizzes">Sample Quizzes</Link>
          {user ? <Link className="button small" to={roleHome[user.role]}>Open Portal</Link> : <Link className="button small" to="/login">Log in</Link>}
        </nav>
      </header>
      <Outlet />
      <footer className="public-footer">
        <img src="/brand/quizpiko-icon.png" alt="QuizPiko icon" />
        <p>QuizPiko Phase 1 Starter â€¢ Child-safe role-based learning platform</p>
      </footer>
    </div>
  );
}

export function HomePage() {
  return (
    <>
      <section className="hero">
        <div className="hero-copy">
          <p className="eyebrow">Learn â€¢ Practise â€¢ Grow</p>
          <h1>Fun learning with Piko, built securely for families and schools.</h1>
          <p>One platform for child-friendly quizzes, teacher assignments, parent reports, math tables and English word practice.</p>
          <div className="hero-actions">
            <Link className="button" to="/register">Create an account</Link>
            <Link className="button secondary" to="/sample-quizzes">Explore the demo</Link>
          </div>
          <div className="trust-row">
            <span>âœ“ No child email required</span>
            <span>âœ“ Role-based access</span>
            <span>âœ“ Mobile-first</span>
          </div>
        </div>
        <div className="hero-art">
          <div className="piko-orbit" />
          <img src="/brand/piko-parrot-mascot.png" alt="Piko, the friendly QuizPiko parrot" />
          <div className="floating-card card-one">16,000 question drafts</div>
          <div className="floating-card card-two">Parents + Teachers</div>
        </div>
      </section>
      <section className="feature-grid page-section">
        {[
          ['Student Learning', 'Large answer cards, Piko reactions, progress and achievements.'],
          ['Parent Portal', 'Child profiles, practice controls, reports and teacher assignments.'],
          ['Teacher Portal', 'Classes, assignments, quiz building and mastery reports.'],
          ['Admin Control', 'Question import, review, versioning, assets and audit history.'],
          ['Math Tables', 'Visual groups, recall, division families and fact mastery.'],
          ['Word World', 'Correct spelling, meanings, examples and personal revision lists.'],
        ].map(([title, text]) => <article key={title}><h2>{title}</h2><p>{text}</p></article>)}
      </section>
    </>
  );
}

export function SimplePublicPage({ title, text }: { title: string; text: string }) {
  return <section className="content-page"><p className="eyebrow">QuizPiko</p><h1>{title}</h1><p>{text}</p></section>;
}


